import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
const _excluded = ["data"];
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useFieldArray } from '@isyc-react/form/modules/rhf';
import { groupByProperty } from '@isyc-react/core/utils';
import { ParameterState } from '@isyc-react/types';
import { RhfInputParameter } from "./rhf-input-parameter.component";
// TODO change for options
import { defaultInputParameterComponents } from "./components";
import "./input-parameter.style.scss";
import { RhfInputMultiParameter } from "./rhf-input-multi-parameter.component";
// TODO repeatable every item if config
export const RhfInputParameterGroup = props => {
  const {
    rhf,
    input,
    justify,
    components = defaultInputParameterComponents,
    options = {}
  } = props;
  const {
    showAddDeleteParameterButtons,
    showAddDeleteMultiparameterButtons
  } = options;
  const {
    control,
    name
  } = rhf;
  const {
      data
    } = input,
    rest = _objectWithoutProperties(input, _excluded);
  const {
    ParameterContainer = defaultInputParameterComponents.ParameterContainer,
    ParameterGroupContainer = defaultInputParameterComponents.ParameterGroupContainer,
    ParameterMultiContainer = defaultInputParameterComponents.ParameterMultiContainer
  } = components;
  const {
    fields,
    update,
    insert,
    remove
  } = useFieldArray(_objectSpread(_objectSpread({}, rhf), {}, {
    keyName: 'rhfInternalId'
  }));
  const assignIndexes = fields => {
    return fields.map((parameter, indexParameter) => {
      if (parameter.childrenParameters) {
        return _objectSpread(_objectSpread({}, parameter), {}, {
          childrenParameters: parameter.childrenParameters.map((child, indexChild) => _objectSpread(_objectSpread({}, child), {}, {
            childrenParameters: undefined,
            index: indexChild
          })),
          index: indexParameter
        });
      } else {
        return _objectSpread(_objectSpread({}, parameter), {}, {
          childrenParameters: undefined,
          index: indexParameter
        });
      }
    });
  };
  const groupFields = React.useMemo(() => {
    const indexedFields = assignIndexes(fields);
    const rawGroupped = groupByProperty(indexedFields, 'groupId');
    const groupped = Object.entries(rawGroupped).map(([, cf]) => ({
      groupId: cf[0].groupId,
      groupName: cf[0].groupName,
      fields: cf
    }));
    return groupped;
  }, [fields]);
  return /*#__PURE__*/React.createElement("div", {
    className: "parameter-group-list-container"
  }, groupFields.map((group, i) => /*#__PURE__*/React.createElement(ParameterGroupContainer, {
    groupName: group.groupName,
    key: `group-${group.groupId}-${i}`
  }, group.fields.map((field, j) => {
    if (field.childrenParameters && field.childrenParameters.length > 0) {
      const parameter = field;
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: `fragment-parameter-${field['rhfInternalId']}`
      }, /*#__PURE__*/React.createElement(ParameterMultiContainer, {
        parameterName: field.label,
        key: `container-parameter-${field['rhfInternalId']}`,
        showAddDeleteButtons: showAddDeleteMultiparameterButtons,
        onInsert: () => {
          var _parameter$childrenPa;
          insert(field.index + 1, _objectSpread(_objectSpread({}, fields[field.index]), {}, {
            id: undefined,
            value: '',
            state: ParameterState.NO_VALIDATION,
            remarks: '',
            childrenParameters: (_parameter$childrenPa = parameter.childrenParameters) === null || _parameter$childrenPa === void 0 ? void 0 : _parameter$childrenPa.map(child => _objectSpread(_objectSpread({}, child), {}, {
              id: undefined,
              value: '',
              state: ParameterState.NO_VALIDATION,
              remarks: ''
            }))
          }));
        },
        onDelete: () => {
          remove(field.index);
        }
      }, /*#__PURE__*/React.createElement(RhfInputParameter // This component basically does nothing, but its required by react-hook-form in order to
      , {
        justify: justify // manage the multiparameter with its children (they are managed by RhfInputMultiParameter)
        ,
        rhf: {
          control,
          name: `${name}.${field.index}`
        },
        input: _objectSpread(_objectSpread({}, rest), {}, {
          data: field
        }),
        key: field['rhfInternalId']
      }), /*#__PURE__*/React.createElement(RhfInputMultiParameter, {
        justify: justify,
        rhf: {
          control,
          name: `${name}.${field.index}.childrenParameters`
        },
        input: _objectSpread(_objectSpread({}, rest), {}, {
          data: field.childrenParameters
        }),
        parentKey: field['rhfInternalId'],
        onChangeChildren: parameters => {
          update(field.index, _objectSpread(_objectSpread({}, fields[field.index]), {}, {
            childrenParameters: parameters
          }));
        }
      })));
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: `fragment-parameter-${field.parameterId}-${j}`
      }, field && /*#__PURE__*/React.createElement(ParameterContainer, {
        parameter: field,
        showAddDeleteButtons: showAddDeleteParameterButtons,
        key: `container-parameter-${field['rhfInternalId']}`,
        onInsert: () => {
          insert(field.index + 1, _objectSpread(_objectSpread({}, fields[field.index]), {}, {
            id: undefined,
            value: '',
            state: ParameterState.NO_VALIDATION,
            remarks: '',
            childrenParameters: undefined
          }));
        },
        onDelete: () => {
          remove(field.index);
        },
        onChangeField: objectWithField => {
          update(field.index, _objectSpread(_objectSpread({}, fields[field.index]), objectWithField));
        }
      }, /*#__PURE__*/React.createElement(RhfInputParameter, {
        justify: justify,
        rhf: {
          control,
          name: `${name}.${field.index}`
        },
        input: _objectSpread(_objectSpread({}, rest), {}, {
          data: field
        }),
        key: field['rhfInternalId']
      })));
    }
  }))));
};